const MobileListCard = ({
  title,
  subtitle,
  badge,
  topRightBadge,
  statusBadge,
  date,
  dateLabel,
  metaItems = [],
  action,
  onClick,
  isSelected = false,
  warning,
  children,
  className = '',
}) => (
  <div
    className={`
      bg-white rounded-xl border transition-all duration-200 overflow-hidden
      ${isSelected
        ? 'border-yellow-500 shadow-md ring-1 ring-yellow-200'
        : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
      }
      ${onClick ? 'cursor-pointer active:scale-[0.99]' : ''}
      ${className}
    `}
    onClick={onClick}
  >
    <div className="p-4 pb-2">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="font-semibold text-gray-900 text-base truncate">{title}</h3>
            {warning && <div className="flex-shrink-0">{warning}</div>}
          </div>
          {subtitle && <p className="text-sm text-gray-500 mt-0.5 truncate">{subtitle}</p>}
        </div>

        {topRightBadge && <div className="flex-shrink-0">{topRightBadge}</div>}

        {action && !topRightBadge && (
          <div className="flex-shrink-0" onClick={(e) => e.stopPropagation()}>
            {action}
          </div>
        )}
      </div>

      {badge && <div className="mt-2.5">{badge}</div>}
    </div>

    {(metaItems.length > 0 || date || statusBadge) && (
      <div className="px-4 pb-4">
        {metaItems.length > 0 && (
          <div className="flex items-center flex-wrap gap-x-4 gap-y-2 text-sm text-gray-500">
            {metaItems.map((item, index) => (
              <div key={index} className="flex items-center gap-1.5">
                {item.icon && <span className="flex-shrink-0">{item.icon}</span>}
                {item.label && <span className="text-gray-400 whitespace-nowrap">{item.label}</span>}
                <span className="text-gray-600">{item.value}</span>
              </div>
            ))}
          </div>
        )}

        {date && metaItems.length === 0 && (
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-1.5 text-sm text-gray-500">
              {dateLabel && <span className="text-gray-400">{dateLabel}</span>}
              <span className="text-gray-600">{date}</span>
            </div>
            {statusBadge && <div className="flex-shrink-0">{statusBadge}</div>}
          </div>
        )}

        {statusBadge && !date && metaItems.length === 0 && (
          <div className="flex justify-end">{statusBadge}</div>
        )}
      </div>
    )}

    {children && <div className="px-4 pb-4">{children}</div>}
  </div>
);

export default MobileListCard;
